import {IconLogout} from '@sportcast/ui-react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAppDispatch} from '../../redux/hooks';
import logout from '../../fetch/logout';
import {hideLoader, showLoader} from '../../redux/action/loaderAction';
import {logoutAction} from '../../redux/action/loginAction';
import {RootState} from '../../redux/rootReducer';
import './Header.scss';

const Header = () => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const loggedIn = useSelector((state: RootState) => state.login.loggedIn);
    const userData = useSelector((state: RootState) => state.login.userData);

    if (!loggedIn) {
        return null;
    }

    function handleLogout() {
        dispatch(showLoader());
        logout().then(() => {
            navigate('/login');
            return dispatch(logoutAction());
        }).finally(() => {
            dispatch(hideLoader());
        });
    }

    const isActive = (path: string) => location.pathname === path;

    const getInitials = () => {
        if (!userData) return '';
        const first = userData.firstName?.charAt(0) || '';
        const last = userData.lastName?.charAt(0) || '';
        return `${first}${last}`;
    };

    return (
        <header className="header-fixed">
            <nav className="header-nav">
                <button
                    className={`nav-item ${isActive('/applications') ? 'active' : ''}`}
                    onClick={() => navigate('/applications')}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="7" height="7" rx="1"/>
                        <rect x="14" y="3" width="7" height="7" rx="1"/>
                        <rect x="3" y="14" width="7" height="7" rx="1"/>
                        <rect x="14" y="14" width="7" height="7" rx="1"/>
                    </svg>
                    <span>{t('header.APPLICATIONS')}</span>
                </button>
                <button
                    className={`nav-item ${isActive('/edit-profile') ? 'active' : ''}`}
                    onClick={() => navigate('/edit-profile')}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                    </svg>
                    <span>{t('header.PROFILE')}</span>
                </button>
            </nav>
            <div className="header-actions">
                {userData && (
                    <div className="user-info">
                        <div className="user-details">
                            <span className="user-name">{userData.firstName} {userData.lastName}</span>
                        </div>
                        <div className="user-avatar">
                            {getInitials()}
                        </div>
                    </div>
                )}
                <button
                    className="nav-item logout"
                    onClick={handleLogout}
                    title={t('header.LOGOUT_USER', {user: `${userData?.firstName} ${userData?.lastName}`})}
                >
                    <IconLogout/>
                </button>
            </div>
        </header>
    );
};

export default Header;
